"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const theme_1 = require("../../../theme");
const Footer_1 = require("../../page-components/Footer");
const DownloadPDFButton_1 = __importDefault(require("../common/DownloadPDFButton"));
const NavigationContext_1 = require("../../../contexts/NavigationContext");
const isNullish_1 = require("../../../util/isNullish");
const styled_components_1 = __importDefault(require("styled-components"));
const common_styled_components_1 = require("../../common-styled-components");
const YearContext_1 = require("../../../contexts/YearContext");
const ToolContent = styled_components_1.default.div `
  width: 100%;
  background-color: ${theme_1.theme.colors.grey(5)};
  padding: ${theme_1.theme.spacing(4)};
  min-height: 600px;
  border-bottom-right-radius: ${common_styled_components_1.DEFAULT_RADIUS};
`;
exports.default = () => {
    const { upPath } = (0, NavigationContext_1.useNavigation)();
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const { years, selectedYear } = (0, YearContext_1.useYear)();
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(ToolContent, { children: [!(0, isNullish_1.isNullish)(upPath) && ((0, jsx_runtime_1.jsx)(NavigationContext_1.UpLinkWithHistory, { to: upPath, children: "Back" })), (0, jsx_runtime_1.jsx)(common_styled_components_1.Navigation, { children: years.map((year) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.NavigationLink, { to: `${pathname}`, paramUpdates: { year: year.toString() }, "$selected": year === selectedYear, children: year }, year))) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {})] }), (0, jsx_runtime_1.jsx)(Footer_1.Footer, { children: (0, jsx_runtime_1.jsx)(DownloadPDFButton_1.default, { label: "Service description (PDF)", fetchUrl: "documentation/ahti_service_description.pdf", fileName: "ahti_service_description.pdf" }) })] }));
};
